import axios from "axios";
import {
	ADD_ROLE_TO_USER_URL,
	AUTH_CHANGE_PASSWORD_URL,
	AUTH_FORGOT_PASSWORD_URL,
	AUTH_LOGIN_URL, AUTH_LOGOUT_URL,
	AUTH_REGIST_COMPANY_URL,
	AUTH_REGIST_COMPANY_USER_URL,
	AUTH_REGISTER_URL,
	GET_ALL_COMPANIES_URL,
	GET_ALL_USERS_BY_CMP_URL,
	GET_ALL_USERS_URL, GET_USERS_COMPANY_URL,
	REMOVE_ROLE_TO_USER_URL,
} from "./utils/ApiUrls";
import {
	ADD_ROLE_TO_USERS_FAIL,
	ADD_ROLE_TO_USERS_START, ADD_ROLE_TO_USERS_SUCCESS,
	AUTH_FAIL,
	AUTH_START,
	AUTH_SUCCESS,
	CHANGE_PASSWORD_FAIL,
	CHANGE_PASSWORD_START,
	CHANGE_PASSWORD_SUCCESS, DELETE_ROLE_TO_USERS_FAIL,
	DELETE_ROLE_TO_USERS_START, DELETE_ROLE_TO_USERS_SUCCESS,
	FORGOT_PASSWORD_FAIL,
	FORGOT_PASSWORD_START,
	FORGOT_PASSWORD_SUCCESS, GET_ALL_COMPANIES_FAIL, GET_ALL_COMPANIES_START, GET_ALL_COMPANIES_SUCCESS,
	GET_ALL_USERS_FAIL,
	GET_ALL_USERS_START,
	GET_ALL_USERS_SUCCESS, GET_USERS_COMPANY_FAIL, GET_USERS_COMPANY_START, GET_USERS_COMPANY_SUCCESS,
	REGIST_FAIL,
	REGIST_START,
	REGIST_SUCCESS,
} from "../reducers/actions/ActionTypes";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {getLoginPazienteApiData, getRegistPazienteApiData, getRegistReferenteCompanyApiData} from "./utils/ApiData";
import {getConfig} from "./utils/ConfigUtils";
import {encriptMessage} from "../utils/SecureData";
import {verifyTokenValidity} from "../utils/TokenUtils";
import {capitalizeWords, getAccountInfo} from "../utils/GenericUtils";

export function authLogout() {
	axios
		.post(AUTH_LOGOUT_URL, {
			codF: getAccountInfo()?.username,
			newPassword: "Viva Cuneo",
			password: "É la vita"
		}, getConfig())
		.then(() => console.log("Arrivederci e alla prossima :)"))
		.catch((error) => {
			alert(JSON.parse(error))
		})
		.finally(() => {
			sessionStorage.clear();
			localStorage.clear();
			window.location.reload();
		})
}

export function resetChangePassword(dispatch) {
	dispatch({type: CHANGE_PASSWORD_START});
}

export function changePassword(data, dispatch) {
	let dataApi = {
		...data,
		codF: getAccountInfo() ? getAccountInfo().username : "Errore",
	}
	console.log(dataApi);
	dispatch({type: CHANGE_PASSWORD_START})
	axios
		.post(AUTH_CHANGE_PASSWORD_URL, dataApi, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				console.log("ok....")
				dispatch({type: CHANGE_PASSWORD_SUCCESS})
			}
		})
		.catch((error) => dispatch({type: CHANGE_PASSWORD_FAIL, error: getErrorMessage(error)}))
}

export function registUser(data, dispatch) {
	dispatch({type: REGIST_START});
	axios
		.post(AUTH_REGISTER_URL, getRegistPazienteApiData(data))
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: REGIST_SUCCESS})
			}
		})
		.catch((error) => dispatch({type: REGIST_FAIL, error: getErrorMessage(error)}))
}

export function loginUser(data, dispatch, location, history) {
	dispatch({type: AUTH_START});
	sessionStorage.clear();
	axios
		.post(AUTH_LOGIN_URL, getLoginPazienteApiData(data))
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				sessionStorage.setItem("key_asl_to", encriptMessage(response.data.token, response.data.token));
				sessionStorage.setItem("inf_asl_to", encriptMessage(JSON.stringify(response.data.accountInfo)));
				sessionStorage.setItem("usr_asl_to", encriptMessage(JSON.stringify(response.data.anagrafica)));
				if (response.data && response.data.companyInfo) {
					sessionStorage.setItem("cmp_asl_to", encriptMessage(JSON.stringify(response.data.companyInfo)));
				}
				if (location.pathname === "/gestione/login" || location.pathname === "/login" || location.pathname === "/gestione/utenti") {
					if (verifyTokenValidity("atlantis", true)) {
						dispatch({type: AUTH_SUCCESS, payload: response.data})
						history.push("/gestione/");
					} else {
						dispatch({type: AUTH_FAIL, error: "Ops, non hai i permessi per accedere a questo servizio"});
					}
				} else if (location.pathname === "/me/login") {
					dispatch({type: AUTH_SUCCESS, payload: response.data})
					history.push("/me/" + response.data.anagrafica.idSoggetto);
				} else if (location.pathname === "/scuole/login") {
					dispatch({type: AUTH_SUCCESS, payload: response.data})
					history.push("/scuole");
				} else if (location.pathname === "/comunita/login") {
					dispatch({type: AUTH_SUCCESS, payload: response.data})
					history.push("/comunita");
				}
			}
		})
		.catch((error) => {
			dispatch({type: AUTH_FAIL, error: getErrorMessage(error)})
		})
}

export function registReferenteCompany(data, dispatch) {
	dispatch({type: REGIST_START});
	axios
		.post(AUTH_REGIST_COMPANY_URL, getRegistReferenteCompanyApiData(data))
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: REGIST_SUCCESS})
			}
		})
		.catch((error) => dispatch({type: REGIST_FAIL, error: getErrorMessage(error)}))
}

export function registerCompanyUser(data, idAzienda, dispatch) {
	dispatch({type: REGIST_START});
	axios
		.post(AUTH_REGIST_COMPANY_USER_URL, {
			...data,
			nome: capitalizeWords(data.nome),
			cognome: capitalizeWords(data.cognome),
			nomeCompany: idAzienda
		}, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: REGIST_SUCCESS})
			}
		})
		.catch((error) => dispatch({type: REGIST_FAIL, error: getErrorMessage(error)}))
}

export function resetRegist(dispatch) {
	dispatch({type: REGIST_START});
}

export function getAllUsers(dispatch) {
	dispatch({type: GET_ALL_USERS_START});
	axios
		.get(GET_ALL_USERS_URL, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: GET_ALL_USERS_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: GET_ALL_USERS_FAIL, error: getErrorMessage(error)}))
}

export function getAllUsersByCompany(id, dispatch) {
	dispatch({type: GET_ALL_USERS_START});
	axios
		.get(GET_ALL_USERS_BY_CMP_URL + id, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: GET_ALL_USERS_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: GET_ALL_USERS_FAIL, error: getErrorMessage(error)}))
}

export function getUsersByCompany(idCompany, dispatch) {
	dispatch({type: GET_USERS_COMPANY_START});
	axios
		.get(GET_USERS_COMPANY_URL + idCompany, getConfig())
		.then((response) => {
			if (response.status === 226){
				authLogout();
			} else {
				dispatch({type: GET_USERS_COMPANY_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: GET_USERS_COMPANY_FAIL, error: getErrorMessage(error)}))
}

export function forgotPassword(username, dispatch) {
	dispatch({type: FORGOT_PASSWORD_START})
	axios
		.post(AUTH_FORGOT_PASSWORD_URL, {codF: username})
		.then(() => dispatch({type: FORGOT_PASSWORD_SUCCESS}))
		.catch((error) => dispatch({type: FORGOT_PASSWORD_FAIL, error: getErrorMessage(error)}))
}

export function removeRoleFromUser(user, role, dispatch, idCmp, referenteDispatch) {
	dispatch({type: DELETE_ROLE_TO_USERS_START})
	axios
		.post(REMOVE_ROLE_TO_USER_URL, {...user, roles: role}, getConfig())
		.then(() => {
			dispatch({type: DELETE_ROLE_TO_USERS_SUCCESS})
			getUsersByCompany(idCmp, referenteDispatch ? referenteDispatch : dispatch);
		})
		.catch((error) => {
			alert(error);
			dispatch({type: DELETE_ROLE_TO_USERS_FAIL, error: getErrorMessage(error)})
		})
}

export function addRolesToUser(user, roles, dispatch, idCmp) {
	dispatch({type: ADD_ROLE_TO_USERS_START});
	axios
		.post(ADD_ROLE_TO_USER_URL, {...user, roles: roles}, getConfig())
		.then(() => {
			dispatch({type: ADD_ROLE_TO_USERS_SUCCESS});
		})
		.catch((error) => {
			alert(error);
			dispatch({type: ADD_ROLE_TO_USERS_FAIL, error: getErrorMessage(error)})
		})
}

export function getAllCompanies(dispatch) {
	dispatch({type: GET_ALL_COMPANIES_START});
	axios
		.get(GET_ALL_COMPANIES_URL, getConfig())
		.then((response) => dispatch({type: GET_ALL_COMPANIES_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_ALL_COMPANIES_FAIL, error: getErrorMessage(error)}))
}
